import React from 'react'

import {
  unitCodeAndNameString,
  unitFullAddressString,
} from 'packages/utils/hkStringHelpers'

import {
  BasicText,
  LinkToMaps,
  UnitInfoSection,
  UnitName,
} from 'app/fieldapp/components/schedule/components/TaskSharedStyles'
import { Unit, UnknownUnit } from 'app/fieldapp/store/units'

const St = {
  LinkToMaps,
  UnitAddress: BasicText,
  UnitInfoSection,
  UnitName,
}

export type VisitAddressInfoProps = {
  unit: Unit
}

export const VisitAddressInfo: React.FC<VisitAddressInfoProps> = React.memo(
  ({ unit }) => {
    const unitNameString = unitCodeAndNameString(unit)
    const addressString = unitFullAddressString(unit)

    return (
      <St.UnitInfoSection>
        <St.UnitName>{unitNameString}</St.UnitName>
        <St.UnitAddress>{addressString}</St.UnitAddress>
        <St.LinkToMaps {...(unit || UnknownUnit)} />
      </St.UnitInfoSection>
    )
  },
)
